import React from 'react';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import Dropdown from '../../Shared/UI/Dropdown/components/Dropdown';

import { verifyExternalJobBoard, rejectExternalJobBoard, archiveExternalJobBoard, toggleDoNotSearchForExternalJobBoards, findExternalJobBoards, cacheExternalJobBoardWebpage, syncExternalJobBoardJobs } from './restApi';

const BiopharmaGroupExternalJobBoards = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError, openUpdateExternalJobBoardModal, openDeleteExternalJobBoardModal, openNewExternalJobBoardModal } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const doNotSearch = biopharmaGroupState?.biopharmaGroup?.doNotSearchForExternalJobBoards;

  const handleFindExternalJobBoards = () => {
    findExternalJobBoards({
      onResponse,
      onError,
      body: {
        authenticityToken,
        biopharmaGroupId: biopharmaGroupState?.biopharmaGroup?.id,
      },
    });
  };

  const handleToggleDoNotSearch = () => {
    toggleDoNotSearchForExternalJobBoards({
      onResponse,
      onError,
      body: {
        authenticityToken,
        biopharmaGroupId: biopharmaGroupState?.biopharmaGroup?.id,
      },
    });
  };

  return (
    <>
      <ActionRow>
        <Button onClick={handleFindExternalJobBoards} disabled={doNotSearch}>
          Find External Job Boards
        </Button>
        <Button onClick={() => openNewExternalJobBoardModal()}>
          New External Job Board
        </Button>
        <Button
          variant={doNotSearch ? 'destructive' : 'secondary'}
          onClick={handleToggleDoNotSearch}
        >
          {doNotSearch ? 'Discovery Disabled' : 'Disable Discovery'}
        </Button>
      </ActionRow>
      <Table>
        <Thead>
          <Tr>
            <Th>URL</Th>
            <Th>State</Th>
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          {biopharmaGroupState?.biopharmaGroup?.externalJobBoards?.map(externalJobBoard => (
            <Tr key={externalJobBoard.id}>
              <Td>
                <a href={externalJobBoard.url} target="_blank" rel="noopener noreferrer">{externalJobBoard.url}</a>
              </Td>
              <Td>{externalJobBoard.aasmState}</Td>
              <Td>
                <Dropdown
                  trigger={<Button variant="secondary" size="sm">Actions</Button>}
                  align="right"
                >
                  <Dropdown.Item onClick={() => openUpdateExternalJobBoardModal(externalJobBoard)}>
                    Update
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      cacheExternalJobBoardWebpage({
                        onResponse,
                        onError,
                        body: {
                          authenticityToken,
                          biopharmaGroupId: biopharmaGroupState?.biopharmaGroup?.id,
                          externalJobBoardId: externalJobBoard.id,
                        },
                      });
                    }}
                  >
                    Cache Webpage
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      syncExternalJobBoardJobs({
                        onResponse,
                        onError,
                        body: {
                          authenticityToken,
                          biopharmaGroupId: biopharmaGroupState?.biopharmaGroup?.id,
                          externalJobBoardId: externalJobBoard.id,
                        },
                      });
                    }}
                  >
                    Sync Jobs
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  {externalJobBoard.aasmState !== 'verified' && (
                    <Dropdown.Item
                      onClick={() => {
                        verifyExternalJobBoard({
                          onResponse,
                          onError,
                          body: {
                            authenticityToken,
                            externalJobBoardId: externalJobBoard.id,
                          },
                        });
                      }}
                    >
                      Verify
                    </Dropdown.Item>
                  )}
                  {externalJobBoard.aasmState !== 'rejected' && (
                    <Dropdown.Item
                      onClick={() => {
                        rejectExternalJobBoard({
                          onResponse,
                          onError,
                          body: {
                            authenticityToken,
                            externalJobBoardId: externalJobBoard.id,
                          },
                        });
                      }}
                    >
                      Reject
                    </Dropdown.Item>
                  )}
                  {externalJobBoard.aasmState !== 'archived' && (
                    <Dropdown.Item
                      onClick={() => {
                        archiveExternalJobBoard({
                          onResponse,
                          onError,
                          body: {
                            authenticityToken,
                            externalJobBoardId: externalJobBoard.id,
                          },
                        });
                      }}
                    >
                      Archive
                    </Dropdown.Item>
                  )}
                  <Dropdown.Divider />
                  <Dropdown.Item
                    onClick={() => openDeleteExternalJobBoardModal(externalJobBoard)}
                    destructive
                  >
                    Delete
                  </Dropdown.Item>
                </Dropdown>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </>
  );
};

export default BiopharmaGroupExternalJobBoards;
